import { useEffect, useState } from "react";

export const useIsMobile = (minWidth?: number) => {
  const [width, setWidth] = useState<number>(window.innerWidth);
  const isMobile = width <= (minWidth || 600);

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }
  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange, {
      passive: true,
    });
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return isMobile;
};
